<template>
    <div id="header">
        <div id="header-left">
            <router-link id="btn-home"
                         class="btn-main-func"
                         :title="i18n.t('tooltip_back_bookshelf')"
                         to="home"
            >
                <img src="~images/btn_home.png">
            </router-link>
            <a id="btn-bookmark"
               class="btn-main-func"
               href="#"
               v-show="props.isLoadComplete"
               :title="i18n.t('tooltip_bookmarks')"
               @click.prevent="toggleBookmark"
            >
                <img src="~images/btn_bookmark.png">
            </a>
        </div>
        <div id="header-middle">
            <div class="bookname" v-show="data.isShowBookname">{{ bookInfoState.ebookname}} </div>
            <!-- karaoke control start-->
            <audio
                    controls
                    v-if="karaokeState.activeAudioSrc"
                    :src="karaokeState.activeAudioSrc"
                    id="karaokePlayer"
            >
            </audio>

            <audio-controller  v-if="karaokeState.activeAudioSrc"
                               :playerId = "'karaokePlayer'">
            </audio-controller>
            <!-- karaoke control end-->

            <!-- playblock control start-->
            <audio
                    controls
                    autoplay
                    v-if="playBlockState.currentSpanIndex>=0 && playBlockState.audioSrcList !== null"
                    :src="playBlockState.audioSrcList[playBlockState.currentSpanIndex]"
                    id="blockPlayer"
            >
            </audio>

            <audio-controller  v-if="playBlockState.currentSpanIndex>=0 && playBlockState.audioSrcList !== null"
                               :playerId = "'blockPlayer'">
            </audio-controller>
            <!-- playblock control end-->


            <!-- playSpan control start-->
            <audio
                    controls
                    autoplay
                    v-if="playBlockState.spanSrc && !playBlockState.id"
                    :src="playBlockState.spanSrc"
                    id="spanPlayer"
            >
            </audio>

            <audio-controller  v-if="playBlockState.spanSrc && !playBlockState.id"
                               :playerId = "'spanPlayer'">
            </audio-controller>
            <!-- playSpan control end-->


            <!-- simple audio control start-->
            <audio
                    autoplay
                    controls
                    v-if="bookInfoState.activeAudioSrc"
                    :src="bookInfoState.activeAudioSrc"
                    id="simpleAudioPlayer"
            >
            </audio>

            <audio-controller  v-if="bookInfoState.activeAudioSrc"
                               :playerId = "'simpleAudioPlayer'">
            </audio-controller>
            <!-- simple audio control end-->


        </div>
        <div id="header-right">
            <a id="btn-toggle-han"
               v-show="props.isLoadComplete"
               class="btn-main-func"
               href="#"
               :class="[data.classToggleHan, data.classIsDisableSpeechAndHanPin]"
               :title="i18n.t('tooltip_han')"
               @click.prevent="toggleGlobalHan"
               v-if="bookInfoState.hanzi"
            >
                <img src="~/images/icon_toggle_han.png">
            </a>
            <a id="btn-toggle-pin"
               v-show="props.isLoadComplete"
               href="#"
               class="btn-main-func"
               :class="[data.classTogglePinYin, data.classIsDisableSpeechAndHanPin]"
               :title="i18n.t('tooltip_pinyin')"
               @click.prevent="toggleGlobalPinYin"
               v-if="bookInfoState.pinyin"
            >
                <img src="~/images/icon_toggle_pinyin.png">
            </a>
            <a id="btn-toggle-speech"
               v-show="props.isLoadComplete && bookInfoState.availableSpeech.length > 1 "
               href="#"
               class="btn-main-func"
               :class="data.classIsDisableSpeechAndHanPin"
               @click.prevent="toggleSpeech"
            >
                <img src="~/images/icon_putonghua.png" v-show="bookInfoState.activeSpeech === 'PN'">
                <img src="~/images/icon_cantonese.png" v-show="bookInfoState.activeSpeech === 'YY'">
            </a>
            <a id="btn-fc"
                href="#"
                class="btn-main-func"
                @click.prevent="launchFC"
                :title="i18n.t('flip_classroom')"
                v-if="bookInfoState.flipClassroom"
            >
                <img src="~/images/btn_fc.png">
            </a>
            <div id="btn-sync-container"
                 :class="data.classBtnSyncContainer"
            >
                <!-- note we use stopPropagation upon click event here, so that the onEmptyAreaClicked method on Reader.vue can be bypassed !-->
                <a id="btn-sync"
                   class="btn-main-func"
                   :class="data.classBtnSync"
                   href="#"
                   v-show="props.isLoadComplete"
                   :title="i18n.t('tooltip_sync')"
                   @click.stop="toggleSyncOptions"
                >
                    <img src="~images/icon_sync.png">
                </a>
                <div id="sync-options"  v-show="bookInfoState.isShowSyncOptions ">
                    <a id="btn-backup"
                       class="btn-main-func"
                       href="#"
                       v-show="props.isLoadComplete"
                       :title="i18n.t('tooltip_backup')"
                       @click.prevent="backup"
                    >
                        <img src="~images/icon_backup.png">
                    </a>
                    <a id="btn-restore"
                       class="btn-main-func"
                       href="#"
                       v-show="props.isLoadComplete"
                       :title="i18n.t('tooltip_restore')"
                       @click.prevent="restore"
                    >
                        <img src="~images/icon_restore.png">
                    </a>
                </div>
            </div>
            <a id="btn-zoomout"
               href="#"
               class="btn-main-func"
               :class="data.classBtnZoomOut"
               v-show="!pageState.isRightPageAvailable && props.isLoadComplete"
               @click.prevent="zoomOut"
               :title="i18n.t('tooltip_zoomout')"
               v-if="deviceType() === 'desktop'"
            >
                <img src="~images/icon_zoomout.png">
            </a>
            <a id="btn-zoomin"
               href="#"
               class="btn-main-func"
               :class="data.classBtnZoomIn"
               v-show="!pageState.isRightPageAvailable &&  props.isLoadComplete"
               @click.prevent="zoomIn"
               :title="i18n.t('tooltip_zoomin')"
               v-if="deviceType() === 'desktop'"
            >
                <img src="~images/icon_zoomin.png">
            </a>
        </div>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watch, watchEffect, computed, nextTick,inject}  from "vue"
    import config from "@/config/config.json";
    import {usePaging}  from "@/modules/reader/book/paging";
    import {useDataLoader} from "@/modules/reader/book/dataLoader";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
    import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";
    import * as synchronizer from  "@/modules/sync/synchronizer";
    import {useTool} from "@/modules/reader/tools/tools";
    import {getCurrentLocalHistory} from "@/modules/localDB/bookQuery";
    import {useBookmark}  from "@/modules/reader/bookmark/bookmark";
    import {isTouchDevice, deviceType, isIOS, isSafari} from "@/modules/utils/deviceUtils";
    import AudioController from "@/views/reader/audio/AudioController";

    export default {
        components:{
            AudioController
        },
        props: {
            isLoadComplete:Boolean
        },
        setup(props, context) {

            const {pageResizeState, zoomIn, zoomOut} = usePageResize();
            const {pageState, setCurrentPage}  = usePaging();
            const {bookInfoState, toggleSpeech, toggleGlobalHan, toggleGlobalPinYin, toggleSyncOptions} = useBookInfo();
            const {karaokeState} = useKaraokeControl();
            const {playBlockState} = usePlayBlockControl();
            const {toolState, closeToolBoxAndPanel} = useTool();
            const {bookmarkState, toggleBookmark} = useBookmark();
            const i18n = inject('i18n');

            const data = reactive({
                isShowSyncOptions:false, //TODO: move to state, so that show sync options will be off if other func buttons are clicked
                classBtnZoomIn: computed(()=> {
                    return (pageResizeState.zoomLevel === config.reader.maxZoom) ? "disabled" : ""
                }),
                classBtnZoomOut: computed(()=> {
                    return (pageResizeState.zoomLevel === config.reader.minZoom) ? "disabled" : ""
                }),
                classToggleHan: computed(()=>{
                    return (bookInfoState.globalHanVisible) ? "active" : "";
                }),
                classTogglePinYin: computed(()=>{
                    return (bookInfoState.globalPinYinVisible) ? "active" : "";
                }),
                //toggle speech/han/pin button should be disabled if playSapn/playBlock/karaoke is active
                classIsDisableSpeechAndHanPin:computed(()=>{
                    return {
                        disabled: (playBlockState.id || playBlockState.spanSrc || karaokeState.activeAudioSrc || bookInfoState.activeAudioSrc)
                    }
                }),
                classBtnSync: computed(()=>{
                    return {
                        "no-hover-shadow": bookInfoState.isShowSyncOptions,
                        "active":bookInfoState.isShowSyncOptions
                    }
                }),
                classBtnSyncContainer:computed(()=>{
                    return {
                        "border-btn-sync-container":bookInfoState.isShowSyncOptions,
                        "disabled":toolState.isSyncProgress ? true : false
                    }
                }),
                isShowBookname: computed(()=>{
                    return (karaokeState.activeAudioSrc === null  &&
                        playBlockState.currentSpanIndex === -1 &&
                        playBlockState.spanSrc === null &&
                        bookInfoState.activeAudioSrc === null
                    );
                }),
            });

            const restore = async ()=>{
                toggleSyncOptions();
                toolState.isSyncProgress = true;
                await synchronizer.restore().catch(e=>{
                    if (e === config.errorcode.general) {
                        alert(i18n.t("error_msg_backup_restore"));
                    }
                });
                toolState.isSyncProgress = false;

                //Important note: canvas isn't cleared on tablet device since the process is expensive.
                //Instead just refresh the browser and load the canvas again with the draw data just restored and saved to local
                if (isTouchDevice()) {
                    location.reload();
                }
            }


            const backup = async() =>{
                toggleSyncOptions();
                toolState.isSyncProgress = true;
                await synchronizer.backup().catch(e=>{
                    if (e === config.errorcode.general) {
                        alert(i18n.t("error_msg_backup_restore"));
                    }
                });
                toolState.isSyncProgress = false;
            }

            const launchFC = ()=>{
                window.open(`${process.env.VUE_APP_SSO_FC}?access_token=${localStorage.accessToken}&subjectcode=${bookInfoState.subjectcode}&gradeid=${bookInfoState.gradecode}`);
            }

            const onCanPlay = (e)=> {
                karaokeState.canPlay = true;
            }


            watchEffect(()=>{
                /*
                if (karaokeState.activeAudioSrc) {
                    document.getElementById("karaokePlayer").addEventListener("canplay", onCanPlay);
                }*/

            })

            return {
                i18n,
                data,
                props,
                karaokeState,
                playBlockState,
                bookInfoState,
                pageState,
                pageResizeState,
                toggleSpeech,
                zoomIn,
                zoomOut,
                restore,
                backup,
                launchFC,
                toggleGlobalHan,
                toggleBookmark,
                toggleGlobalPinYin,
                isTouchDevice,
                deviceType,
                isIOS,
                toggleSyncOptions
            }
        }
    }
</script>

<style scoped lang="scss">

    #header-left {
        flex:1;
    }

    #header-middle {
        flex-basis:630px;
        color:#fff;
    }

    #header-right {
        flex:1;
    }

    audio {
        display:none;
    }

    #btn-restore {
        color:#fff;
    }

    .no-hover-shadow {
        border-radius: 0 !important;
        box-shadow: none !important;
    }

    .border-btn-sync-container {
        border-radius: 2px;
        box-shadow: 0px 0px 0px 2px $color-primary-bright;
    }

    #btn-sync-container {

        width:$btn-main-func-size;
        height:$btn-main-func-size;
        position:relative;

        a {
            display:block;
            margin:0;
        }
        #btn-sync {
            position:relative;

            &.active {
                 @extend .no-hover-shadow !optional;
            }
        }

        #sync-options {
            position:absolute;
            border-radius: 0 0 2px 2px !important;
            @include btn-main-func-hover-active;

            a {
                margin: 0 !important;
                background-color: $color-primary;

                &:hover, &.active {
                    @extend .no-hover-shadow !optional;
                }
            }
        }

    }



</style>